module.exports = __webpack_public_path__ + "static/media/ZM.c299a7de.svg";